$(function() {
  
  var elements = document.querySelectorAll('.u-sticky');
  Stickyfill.add(elements);

});
